import { IGradebookReducer } from '../Interfaces/IGradebookReducer';
import { StudentExercisesResultResponse } from '../Types/StudentExercisesResultResponse';
import { CriteriaGroupResponse } from '../Types/CriteriaGroupResponse';

export const studentExercisesResultInitState: StudentExercisesResultResponse = {
  data: { students: [] },
  metadata: {},
};

export const studentExerciseFetchInProgressInitState = false;

export const setPointsForCriteriaInProgressInitState = [];

export const setPointsForExerciseInProgressInitState = [];

export const criteriaGroupsInitState: CriteriaGroupResponse = {
  data: [],
  metadata: {},
};

export const setPublicationsInProgressInitState = [];

export const setMaxMinPointsForStudentInitState = [];

export const gradebookInitState: IGradebookReducer = {
  criteriaGroups: criteriaGroupsInitState,
  studentExercisesResult: studentExercisesResultInitState,
  studentExerciseFetchInProgress: studentExerciseFetchInProgressInitState,
  setPointsForCriteriaInProgressId: setPointsForCriteriaInProgressInitState,
  setPointsForExerciseInProgressId: setPointsForExerciseInProgressInitState,
  setPublicationsInProgressId: setPublicationsInProgressInitState,
  setPointsForStudentInProgressId: setMaxMinPointsForStudentInitState,
};
